import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { blogAuthorPropType, blogPostPropType } from '../../constants/propTypes'
import SideBar from './SideBar'
import Author from './Author'

const Container = styled.div`
  ul {
    list-style: none;
  }
`

const Head = styled.div`
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.primaryHighlight};
  padding-bottom: 1rem;
  margin-bottom: 1rem;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`

const AuthorSideBar = (props) => (
  <Container>
    <Head>
      <Author {...props} />
    </Head>
    <SideBar posts={props.recentPosts} filters={props.filters} />
  </Container>
)

AuthorSideBar.propTypes = {
  ...blogAuthorPropType,
  recentPosts: PropTypes.arrayOf(PropTypes.shape(blogPostPropType)).isRequired,
  filters: PropTypes.object.isRequired
}

export default AuthorSideBar
